<template>
  <d-container fluid class="main-content-container px-0">
    <order-wrapper v-if="!userIsCustomer" />
    <request-wrapper v-else />
  </d-container>
</template>

<script>
import CustomerPanel from './../../mixins/CustomerPanel.vue';
import OrderWrapper from './OrderWrapper.vue';
import RequestWrapper from './RequestWrapper.vue';

export default {
  name: 'order-view-proxy',
  mixins: [
    CustomerPanel
  ],
  components: {
    'order-wrapper': OrderWrapper,
    'request-wrapper': RequestWrapper
  }
}
</script>
